import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'uk',
  months: [
    'січня',
    'лютого',
    'березня',
    'квітня',
    'травня',
    'червня',
    'липня',
    'серпня',
    'вересня',
    'жовтня',
    'листопада',
    'грудня',
  ],
  monthsShort: ['січ.', 'лют.', 'бер.', 'квіт.', 'трав.', 'черв.', 'лип.', 'серп.', 'вер.', 'жовт.', 'лист.', 'груд.'],
  weekdays: ['Неділя', 'Понеділок', 'Вівторок', 'Середа', 'Четвер', 'П’ятниця', 'Субота'],
  weekdaysMin: ['Н', 'П', 'В', 'С', 'Ч', 'П', 'С'],
  weekdaysShort: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: 'DD.MM.YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'DD.MM.YYYY',
    'l-Y': 'DD.MM',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'дп', pm: 'пп', AM: 'дп', PM: 'пп' },
  past: {
    y: { one: '%s р. тому', few: '%s р. тому', many: '%s р. тому', other: '%s р. тому' },
    M: { one: '%s міс. тому', few: '%s міс. тому', many: '%s міс. тому', other: '%s міс. тому' },
    w: { one: '%s тиж. тому', few: '%s тиж. тому', many: '%s тиж. тому', other: '%s тиж. тому' },
    d: { one: '%s дн. тому', few: '%s дн. тому', many: '%s дн. тому', other: '%s дн. тому' },
    h: { one: '%s год тому', few: '%s год тому', many: '%s год тому', other: '%s год тому' },
    m: { one: '%s хв тому', few: '%s хв тому', many: '%s хв тому', other: '%s хв тому' },
    s: { one: '%s с тому', few: '%s с тому', many: '%s с тому', other: '%s с тому' },
  },
  future: {
    y: { one: 'через %s р.', few: 'через %s р.', many: 'через %s р.', other: 'через %s р.' },
    M: { one: 'через %s міс.', few: 'через %s міс.', many: 'через %s міс.', other: 'через %s міс.' },
    w: { one: 'через %s тиж.', few: 'через %s тиж.', many: 'через %s тиж.', other: 'через %s тиж.' },
    d: { one: 'через %s дн.', few: 'через %s дн.', many: 'через %s дн.', other: 'через %s дн.' },
    h: { one: 'через %s год', few: 'через %s год', many: 'через %s год', other: 'через %s год' },
    m: { one: 'через %s хв', few: 'через %s хв', many: 'через %s хв', other: 'через %s хв' },
    s: { one: 'через %s с', few: 'через %s с', many: 'через %s с', other: 'через %s с' },
  },
  pastLong: {
    y: { one: '%s рік тому', few: '%s роки тому', many: '%s років тому', other: '%s року тому' },
    M: { one: '%s місяць тому', few: '%s місяці тому', many: '%s місяців тому', other: '%s місяця тому' },
    w: { one: '%s тиждень тому', few: '%s тижні тому', many: '%s тижнів тому', other: '%s тижня тому' },
    d: { one: '%s день тому', few: '%s дні тому', many: '%s днів тому', other: '%s дня тому' },
    h: { one: '%s годину тому', few: '%s години тому', many: '%s годин тому', other: '%s години тому' },
    m: { one: '%s хвилину тому', few: '%s хвилини тому', many: '%s хвилин тому', other: '%s хвилини тому' },
    s: { one: '%s секунду тому', few: '%s секунди тому', many: '%s секунд тому', other: '%s секунди тому' },
  },
  futureLong: {
    y: { one: 'через %s рік', few: 'через %s роки', many: 'через %s років', other: 'через %s року' },
    M: { one: 'через %s місяць', few: 'через %s місяці', many: 'через %s місяців', other: 'через %s місяця' },
    w: { one: 'через %s тиждень', few: 'через %s тижні', many: 'через %s тижнів', other: 'через %s тижня' },
    d: { one: 'через %s день', few: 'через %s дні', many: 'через %s днів', other: 'через %s дня' },
    h: { one: 'через %s годину', few: 'через %s години', many: 'через %s годин', other: 'через %s години' },
    m: { one: 'через %s хвилину', few: 'через %s хвилини', many: 'через %s хвилин', other: 'через %s хвилини' },
    s: { one: 'через %s секунду', few: 'через %s секунди', many: 'через %s секунд', other: 'через %s секунди' },
  },
  abbr: {
    y: { one: '%s р.', few: '%s р.', many: '%s р.', other: '%s р.' },
    M: { one: '%s міс.', few: '%s міс.', many: '%s міс.', other: '%s міс.' },
    w: { one: '%s тиж.', few: '%s тиж.', many: '%s тиж.', other: '%s тиж.' },
    d: { one: '%s день', few: '%s дні', many: '%s днів', other: '%s дня' },
    h: { one: '%s год', few: '%s год', many: '%s год', other: '%s год' },
    m: { one: '%s хв', few: '%s хв', many: '%s хв', other: '%s хв' },
    s: { one: '%s с', few: '%s с', many: '%s с', other: '%s с' },
  },
  full: {
    y: { one: '%s рік', few: '%s роки', many: '%s років', other: '%s року' },
    M: { one: '%s місяць', few: '%s місяці', many: '%s місяців', other: '%s місяця' },
    w: { one: '%s тиждень', few: '%s тижні', many: '%s тижнів', other: '%s тижня' },
    d: { one: '%s день', few: '%s днів', many: '%s днів', other: '%s дня' },
    h: { one: '%s година', few: '%s години', many: '%s годин', other: '%s години' },
    m: { one: '%s хвилина', few: '%s хвилини', many: '%s хвилин', other: '%s хвилини' },
    s: { one: '%s секунда', few: '%s секунди', many: '%s секунд', other: '%s секунди' },
  },
  justNow: 'щойно',
  yesterday: 'Учора',
  today: 'Сьогодні',
  tomorrow: 'Завтра',
  weekStart: 1,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'h:mm A': 'HH:mm' },
  timeRangeStyles: {
    yl: { start: 'D MMMM YYYY [р].', end: 'D MMMM YYYY [р].' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM YYYY [р].' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM YYYY [р].' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM YYYY', end: 'D MMM YYYY [рр].' },
    'y-1': { start: 'D MMM', end: 'D MMM YYYY [р].' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM YYYY [р].' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM YYYY', end: 'ddd, D MMM YYYY [рр].' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM YYYY [р].' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D', end: 'ddd, D MMM' },
    yt: { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY [рр]., HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM YYYY, HH:mm', end: 'D MMM YYYY [рр]., HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'uk';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'дп' : 'дп';
    } else {
      return isLowerCase ? 'пп' : 'пп';
    }
  },
};
